import { render, staticRenderFns } from "./recibo-pagamento-escola.vue?vue&type=template&id=38ec69ee&scoped=true&"
import script from "./recibo-pagamento-escola.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola.vue?vue&type=style&index=0&id=38ec69ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec69ee",
  null
  
)

export default component.exports